// Message value object: canonical `type` vocabulary + factory, so message types stop
// being magic strings. Pure leaf module (no imports) — safe for any layer to depend on.

/** Legacy persisted value for the agent type, before it was normalized to lowercase. */
export const LEGACY_AGENT_TYPE = 'AGENT';

/**
 * Canonical message-type vocabulary, all lowercase. IMAGE and IMAGE_FALLBACK exist only for
 * rows persisted before agent images carried their image data on the message.
 */
export const MessageType = {
  USER: 'user',
  BOT: 'bot',
  SYSTEM: 'system',
  ADD_TO_CART: 'add-to-cart',
  AGENT: 'agent',
  IMAGE: 'image',
  IMAGE_FALLBACK: 'imageFallback',
};

/**
 * Coerce a legacy persisted message (uppercase 'AGENT') onto the canonical type at read time.
 * Returns the same object when nothing changes. See .claude/context/persistence.md
 * @param {Object} message
 * @returns {Object}
 */
export const normalizeLegacyMessageType = (message) => (
  message?.type === LEGACY_AGENT_TYPE ? { ...message, type: MessageType.AGENT } : message
);

/**
 * Build a conversation-message payload: `type`, `content`, and `extras` merged as-is.
 * `useMessageHistory.saveMessage` adds the persistence fields later, not this function.
 * @param {string} type - a MessageType value
 * @param {*} content
 * @param {Object} [extras]
 * @returns {Object}
 */
export const createMessage = (type, content, extras = {}) => ({
  type,
  content,
  ...extras,
});
